#import "@/components/common/LinkFragment.gql"

fragment TeaserWithMultipleCtasFragment on teaserWithMultipleCtas_Entry {
  typeHandle
  teasers {
    ... on teasersBlock_Entry {
      image {
        url
        title
      }
      alt
      heading
      body
      articleLinks {
        ... on articleLinksBlock_Entry {
          articleLink {
            ...LinkFragment
          }
        }
      }
    }
  }
}
